var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['v-btn', _vm.buttonSize, _vm.buttonVariant, _vm.buttonBlock, _vm.buttonPill],attrs:{"type":_vm.type},on:{"click":_vm.clicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }